import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { selectCurrentProvider, startRating, addressLocation, emailAddress, thanks } from './common-steps'

export const customerServiceReview: ScenarioStep = {
  id: Steps.CUSTOMER_SERVICE,
  group: QuestionGroup.REVIEWS,
  question: 'customer-service_question',
  tip: 'customer-service_tip',
  type: QuestionType.STARS,
  next: Steps.NETWORK,
  answers: [],
  metadata: { grandImage: Images.REVIEW_4 },
}

export const networkReview: ScenarioStep = {
  id: Steps.NETWORK,
  group: QuestionGroup.REVIEWS,
  question: 'network_question',
  tip: 'network_tip',
  type: QuestionType.STARS,
  next: Steps.BILL,
  answers: [],
  metadata: { grandImage: Images.REVIEW_5 },
}

export const billReview: ScenarioStep = {
  id: Steps.BILL,
  group: QuestionGroup.REVIEWS,
  question: 'bill_question',
  tip: 'bill_tip',
  type: QuestionType.STARS,
  next: Steps.DIGITAL_EXPERIENCE,
  answers: [],
  metadata: { grandImage: Images.REVIEW_6 },
}

export const digitalExperienceReview: ScenarioStep = {
  id: Steps.DIGITAL_EXPERIENCE,
  group: QuestionGroup.REVIEWS,
  question: 'digital-experience_question',
  tip: 'digital-experience_tip',
  type: QuestionType.STARS,
  next: Steps.ONBOARDING_EXPERIENCE,
  answers: [],
  metadata: { grandImage: Images.REVIEW_7 },
}

export const onboardingExperienceReview: ScenarioStep = {
  id: Steps.ONBOARDING_EXPERIENCE,
  group: QuestionGroup.REVIEWS,
  question: 'onboarding-experience_question',
  tip: 'onboarding-experience_tip',
  type: QuestionType.STARS,
  next: Steps.RECOMMEND_PROVIDER,
  answers: [],
  metadata: { grandImage: Images.REVIEW_9 },
}

export const nameNickname: ScenarioStep = {
  id: Steps.NAME_NICKNAME,
  group: QuestionGroup.REVIEWS,
  question: 'name-nickname_question',
  tip: 'name-nickname_tip',
  type: QuestionType.INPUT_DEFAULT,
  answerPlaceholder: 'name-nickname_answerPlaceholder',
  next: Steps.SELECT_CURRENT_PROVIDER,
  answers: [],
  metadata: { grandImage: Images.REVIEW_1, inputType: 'name' },
}

export const recommendProviderReview: ScenarioStep = {
  id: Steps.RECOMMEND_PROVIDER,
  group: QuestionGroup.REVIEWS,
  question: 'recommend-provider_question',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.FINAL_WORD,
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
    },
    {
      id: 'no',
      text: 'common_no',
    },
  ],
  metadata: { grandImage: Images.REVIEW_10 },
}

export const recommendProviderReviewB: ScenarioStep = {
  ...recommendProviderReview,
  next: Steps.FINAL_WORD_REFERRAL_CODE,
}

export const finalWordReview: ScenarioStep = {
  id: Steps.FINAL_WORD,
  group: QuestionGroup.REVIEWS,
  question: 'final-word_question',
  tip: 'final-word_tip',
  type: QuestionType.TEXTAREA,
  answerPlaceholder: 'final-word_answerPlaceholder',
  next: Steps.CONFIRM_REVIEW,
  answers: [],
}

export const finalWordWithReferralCodeReview: ScenarioStep = {
  id: Steps.FINAL_WORD_REFERRAL_CODE,
  group: QuestionGroup.REVIEWS,
  question: 'final-word_question',
  tip: 'final-word_tip',
  type: QuestionType.TEXTAREA_REFERRAL_CODE,
  answerPlaceholder: 'final-word_answerPlaceholder',
  next: Steps.CONFIRM_REVIEW,
  answers: [],
}

export const finalWordWithReferralCodeReviewC: ScenarioStep = {
  ...finalWordWithReferralCodeReview,
  next: Steps.ADDRESS_LOCATION,
}

export const finalWordWithReferralCodeReviewD: ScenarioStep = {
  ...finalWordWithReferralCodeReview,
  next: Steps.CONFIRM_REVIEW,
}

export const addressLocationReviews: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.REVIEWS,
  question: 'address-location_question',
  next: Steps.START_RATING,
}

export const addressLocationReviewsC: ScenarioStep = {
  ...addressLocationReviews,
  next: Steps.CONFIRM_REVIEW,
}

export const emailAddressReview: ScenarioStep = {
  ...emailAddress,
  next: Steps.NAME_NICKNAME,
}

export const ThanksRating: ScenarioStep = {
  ...thanks,
  question: 'thanks-rating_question',
  tip: 'thanks-rating_tip',
}

export const startRatingMobile: ScenarioStep = {
  ...startRating,
  question: { key: 'start-rating_question', options: { providerName: '', providerType: 'mobile' } },
  next: Steps.CUSTOMER_SERVICE,
}

export const startRatingInternet: ScenarioStep = {
  ...startRating,
  question: { key: 'start-rating_question', options: { providerName: '', providerType: 'internet' } },
  next: Steps.CUSTOMER_SERVICE,
}

export const selectCurrentProviderMobile: ScenarioStep = {
  ...selectCurrentProvider,
  question: { key: 'select-current-provider_question', options: { providerType: 'Mobile' } },
  next: Steps.ADDRESS_LOCATION,
}

export const selectCurrentProviderMobileC: ScenarioStep = {
  ...selectCurrentProviderMobile,
  next: Steps.START_RATING,
}

export const selectCurrentProviderInternet: ScenarioStep = {
  ...selectCurrentProvider,
  question: { key: 'select-current-provider_question', options: { providerType: 'Internet' } },
  next: Steps.ADDRESS_LOCATION,
}

export const confirmReview: ScenarioStep = {
  id: Steps.CONFIRM_REVIEW,
  group: QuestionGroup.REVIEWS,
  type: QuestionType.CHECKBOX_CONFIRM,
  answerPlaceholder: 'confirm-review_answerPlaceholder',
  answers: [{ id: 'confirm-alert', text: 'common_confirm' }],
  next: Steps.THANKS,
}
